import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./DeactivateMultifactorAuthenticationWarningPopup.module.scss";

interface IDeactivateMultifactorAuthenticationWarningPopupProps {
    onCancel: () => void;
    onConfirm: () => void;
}

function DeactivateMultifactorAuthenticationWarningPopup(props: IDeactivateMultifactorAuthenticationWarningPopupProps): JSX.Element {
    const { getText } = useTranslation();

    function renderFooter(): JSX.Element {
        return (
            <div className={styles.footerContainer}>
                <ButtonGroup>
                    <ButtonControl
                        onClick={props.onCancel}
                        className="btn btn-default"
                        label={getText("CancelLabel")}
                    />
                    <ButtonControl
                        onClick={props.onConfirm}
                        className="btn btn-danger"
                        label={getText("ConfirmLabel")}
                    />
                </ButtonGroup>
            </div>
        );
    }

    const formatMessage = getText("MultifactorAuthentication_DeactivateMultifactorAuthenticationWarningMessage")
        .split("\\n"); // split on escaped newlines

    return (
        <Modal
            title={getText("MultifactorAuthentication_DeactivateMultifactorAuthenticationLabel")}
            showOverlay
            footer={renderFooter()}
        >
            <div>
                {formatMessage.map((text, index) => <><p key={`${text},${index}`}>{text}</p><br /></>)}
            </div>
        </Modal>
    );
}

export { DeactivateMultifactorAuthenticationWarningPopup };
